export default function App() {
  return <div>Hello from CDN!</div>;
}
